import { render, staticRenderFns } from "./dartboard-player.vue?vue&type=template&id=1034e216&scoped=true&lang=pug&"
import script from "./dartboard-player.vue?vue&type=script&lang=ts&"
export * from "./dartboard-player.vue?vue&type=script&lang=ts&"
import style0 from "./dartboard-player.vue?vue&type=style&index=0&id=1034e216&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1034e216",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
